import React from 'react';
import { useLanguage } from '../utils/i18n';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import LanguageToggle from '../components/LanguageToggle';
import { Users, Target, Award, Mail } from 'lucide-react';
import '../index.css';

export default function AboutUs() {
    const { t } = useLanguage();

    return (
        <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
            {/* Navbar */}
            <nav className="navbar">
                <Link to="/" className="navbar-brand">
                    <Logo size={24} />
                    <span>Wafiyo</span>
                </Link>
                <LanguageToggle />
            </nav>

            <div className="container" style={{ maxWidth: 800, paddingTop: 100, paddingBottom: 80 }}>
                <div style={{ textAlign: 'center', marginBottom: 40 }}>
                    <div className="badge glass-badge" style={{ marginBottom: 16 }}>
                        <span>Wafiyo</span>
                    </div>
                    <h1 style={{ fontSize: 40, fontWeight: 800, letterSpacing: '-0.5px' }}>
                        {t('about_title')}
                    </h1>
                </div>

                <div className="glass-card" style={{ padding: '40px', display: 'flex', flexDirection: 'column', gap: '40px' }}>

                    <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                        <div style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '12px', borderRadius: '12px', color: '#3b82f6' }}>
                            <Users size={24} />
                        </div>
                        <div>
                            <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12, color: 'var(--text)' }}>
                                {t('about_who_we_are_title').replace(/^1\.\s*/, '')}
                            </h2>
                            <p style={{ color: 'var(--text-muted)', lineHeight: 1.7, fontSize: 16 }}>
                                {t('about_who_we_are_text')}
                            </p>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                        <div style={{ background: 'rgba(16, 185, 129, 0.1)', padding: '12px', borderRadius: '12px', color: '#10b981' }}>
                            <Target size={24} />
                        </div>
                        <div>
                            <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12, color: 'var(--text)' }}>
                                {t('about_mission_title').replace(/^2\.\s*/, '')}
                            </h2>
                            <p style={{ color: 'var(--text-muted)', lineHeight: 1.7, fontSize: 16 }}>
                                {t('about_mission_text')}
                            </p>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                        <div style={{ background: 'rgba(245, 158, 11, 0.1)', padding: '12px', borderRadius: '12px', color: '#f59e0b' }}>
                            <Award size={24} />
                        </div>
                        <div>
                            <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12, color: 'var(--text)' }}>
                                {t('about_why_choose_us_title').replace(/^3\.\s*/, '')}
                            </h2>
                            <p style={{ color: 'var(--text-muted)', lineHeight: 1.7, fontSize: 16 }}>
                                {t('about_why_choose_us_text')}
                            </p>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                        <div style={{ background: 'rgba(139, 92, 246, 0.1)', padding: '12px', borderRadius: '12px', color: '#8b5cf6' }}>
                            <Mail size={24} />
                        </div>
                        <div>
                            <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12, color: 'var(--text)' }}>
                                {t('about_contact_title').replace(/^4\.\s*/, '')}
                            </h2>
                            <p style={{ color: 'var(--text-muted)', lineHeight: 1.7, fontSize: 16 }}>
                                {t('about_contact_text')}
                            </p>
                        </div>
                    </div>

                </div>

                <div style={{ textAlign: 'center', marginTop: 40 }}>
                    <Link to="/" className="btn btn-outline glass-btn">
                        {t('back_to_home')}
                    </Link>
                </div>
            </div>
        </div>
    );
}
